import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Formik, Form } from "formik";
import { Grid, Paper } from "@mui/material";
import { getSmartkioskInitialValues } from "app/pages/customers/dsok/utils/getSmartkioskInitialValues";
import SmartkioskColors from "app/pages/customers/dsok/smartkioskFields/SmartkioskColors";
import DsokCustomerDetailLayout from "../components/DsokCustomerDetailLayout";
import DsokCustomerDetailDirtySync from "../components/DsokCustomerDetailDirtySync";
import DsokCustomerDetailSectionRegister from "../components/DsokCustomerDetailSectionRegister";
import { useDsokCustomerDetail } from "../data/useDsokCustomerDetail";

const COLORS_FIELD_NAME = "SMARTKIOSK_COLORS";

const DsokCustomerColorsPage = () => {
  const { t } = useTranslation();
  const { customer } = useDsokCustomerDetail();
  const [expanded, setExpanded] = useState(COLORS_FIELD_NAME);
  const handleChange = (panel) => (_event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const formInitialValues = useMemo(() => {
    if (!customer) return { colors: {} };
    const full = getSmartkioskInitialValues(customer);
    return full ?? { colors: {} };
  }, [customer]);

  return (
    <DsokCustomerDetailLayout
      lastBreadcrumbLabel={t("dsokCustomerDetail.sections.colors.title")}
    >
      <Paper variant="outlined" sx={{ bgcolor: "background.paper", p: 2, borderRadius: 1 }}>
        <Formik initialValues={formInitialValues} enableReinitialize onSubmit={() => {}}>
          <Form>
            <DsokCustomerDetailDirtySync />
            <DsokCustomerDetailSectionRegister
              sectionId="colors"
              getPayload={(values) => values.colors ?? {}}
            />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <SmartkioskColors handleChange={handleChange} expanded={expanded} hideSectionTitle />
              </Grid>
            </Grid>
          </Form>
        </Formik>
      </Paper>
    </DsokCustomerDetailLayout>
  );
};

export default DsokCustomerColorsPage;
